/**
 * InputText Label Wrapper Classes
 */

const inputLabelWrapperClasses = 'flex flex-col gap-1';

/**
 * Site Theme
 */

const inputTextSiteTheme = {
  inputLabelWrapperThemeClasses: inputLabelWrapperClasses,
};

export default inputTextSiteTheme;
